import { useSelector } from 'react-redux'
import EventEmitter, {
  SHOW_POPUP_FACTSHEET,
} from '../../../../helpers/EventEmitter'
import useCompanyHeader from '../../../category/useCompanyHeader'
import { ButtonCheckoutCustom } from '../../buttonCheckoutCustom'
import { BUTTON_TYPES } from '../../buttonCheckoutCustom/constants'
import { AddToCart } from '../../cart'
import { BLOCK_TYPE } from '../constants'
import {
  selectDataAvailabilityDetails,
  selectFactSheetChecked,
  selectFsType,
  selectSource,
  selectSources,
} from '../store/slice'
import classes from './index.module.scss'

export const ActionButton = ({ data }) => {
  const checked = useSelector(selectFactSheetChecked)
  const source = useSelector(selectSource)
  const sources = useSelector(selectSources)
  const fsType = useSelector(selectFsType)
  const dataAvailabilities = useSelector(selectDataAvailabilityDetails)
  const { reportingDate } =
    data?.dataBlocks.find((item) => item.id === BLOCK_TYPE.SCORE) || {}
  const { companyHeader } = useCompanyHeader({ disableCallApi: true })
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className={classes.container}>
      <AddToCart
        isFactSheet
        data={[
          {
            fiinGateReportTypeId: data.fiinGateReportTypeId,
            organizationId: data.organizationId,
            companyName: companyHeader.organizationName,
            taxCode: companyHeader.taxCode,
            languageCode: locale,
            availableData: data.availableData,
            dataBlocks: Object.keys(checked)
              .filter((id) => checked[id])
              .map((id) => {
                switch (+id) {
                  case BLOCK_TYPE.FINANCIAL_STATEMENT:
                    return {
                      dataBlockId: +id,
                      reportSourceId: sources.find(
                        (item) => item?.sourceOrganizationId === source,
                      )?.id,
                      consolidated: fsType,
                      dataAvailabilities: dataAvailabilities.map((item) => ({
                        year: item.year,
                        audited: item.audited,
                        isDirect: item.isDirect,
                        available: item.available,
                      })),
                    }

                  case BLOCK_TYPE.SCORE:
                    return {
                      dataBlockId: +id,
                      reportingDate,
                    }

                  default:
                    return {
                      dataBlockId: +id,
                    }
                }
              }),
          },
        ]}
      >
        {(handleAddToCart) => (
          <>
            <ButtonCheckoutCustom
              type={BUTTON_TYPES.ADD_TO_CART}
              onClick={() => {
                EventEmitter.dispatch(SHOW_POPUP_FACTSHEET, false)
                handleAddToCart(true)
              }}
            />
            <ButtonCheckoutCustom
              type={BUTTON_TYPES.BUY_NOW}
              onClick={() => {
                EventEmitter.dispatch(SHOW_POPUP_FACTSHEET, false)
                handleAddToCart()
              }}
            />
          </>
        )}
      </AddToCart>
    </div>
  )
}
